import { Stack } from '@mui/material';
import { CheckboxElement, TextFieldElement, useFormContext, useWatch } from 'react-hook-form-mui';
import AxiosErrorAlert from '../../../../Shared/Alerts/AxiosErrorAlert';
import ButtonLoading from '../../../../Shared/ButtonLoading';

interface Props {
    isLoading: boolean;
    isError: boolean;
    error: any;
}

export function CreateSmartReplyPlanItemFormControls({ isLoading, isError, error }: Props) {
    const {
        formState: { isValid },
    } = useFormContext();

    const repeats = useWatch({ name: 'repeats' }) as boolean;

    return (
        <Stack spacing={2} p={2}>
            <TextFieldElement name="name" label="Title" variant="outlined" fullWidth required />
            <TextFieldElement
                id="prompt"
                name="prompt"
                label="Prompt"
                variant="outlined"
                multiline
                required
                fullWidth
            />
            <CheckboxElement name="repeats" label="Repeats" />
            {repeats && (
                <TextFieldElement
                    name="repeatLimit"
                    label="Max number of times to repeat - Leave empty for unlimited"
                    variant="outlined"
                    type="number"
                    validation={{ min: { value: 1, message: 'Must be at least 1' } }}
                    fullWidth
                />
            )}
            <ButtonLoading
                isLoading={isLoading}
                isError={isError}
                variant="contained"
                color="success"
                type="submit"
                disabled={!isValid}
                fullWidth
            >
                Create
            </ButtonLoading>
            <AxiosErrorAlert error={error} />
        </Stack>
    );
}
